import { render } from "./CdmPage.vue?vue&type=template&id=248d7c19"
import script from "./CdmPage.vue?vue&type=script&lang=js"
export * from "./CdmPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__